export const downloadExcelFile = `query ($filter: ExportExcelRequest) {
    exportExcel(filter: $filter) {
            name,
            content
        }
    }`;